import { z } from 'zod';

/**
 * What one member decided about another (P16).
 *
 * Both decisions are stored, and in the **same** row: a pass is not the absence
 * of a like, it is a member saying "not this one", and the nomination batch
 * (P16b) needs to tell the two apart from "never shown". One row per ordered
 * pair means changing your mind is an upsert rather than a second opinion the
 * reader has to date-order.
 */
export const LIKE_DECISIONS = ['like', 'pass'] as const;

export const LikeDecisionSchema = z.enum(LIKE_DECISIONS);

export type LikeDecision = (typeof LIKE_DECISIONS)[number];

/**
 * Could this decision, met by its mirror image, create a match?
 *
 * The predicate exists so "a match needs two likes" is spelled **once**: the
 * reciprocal lookup, the mutual flag on a list row and the match attempt all
 * read it, and a third decision added later cannot quietly become matchable in
 * one of the three.
 */
export function isMutualCandidate(decision: LikeDecision): boolean {
  return decision === 'like';
}
